import React, { useState, useEffect,useRef } from 'react';
import { Button, Checkbox, Link, Grid, FormControl, FormControlLabel, InputLabel, MenuItem, Select, Tooltip, TextField } from '@mui/material'
import Dialog from '@mui/material/Dialog';
import ImageComponents from '../../../../Shared/ImageComponents'
import UpiPaymentDialog from '../../../../Shared/UpipaymentDialog';
import PaymentSteps from '../../../PaymentSteps/PaymentSteps';
import UpiQR from './UpiQR';
import CustomizedDialogs from "../../../../Shared/CustomDialogs";
import UpiPaymentProcess from './UpiPaymentProcess';
import OTMUpiPaymentProcess from './OTMUpiPaymentProcess';
import PaymentFailedPopup from './upiRetry';
import fetchTxnStatus from '../../Components/fetchTxnStatus';
import Loader from '../../Components/loader';
import getDomain from '../../Components/getDomain';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import IntentPaymentStatusDialog from './IntentPaymentStatusDialog';


function UpiOtm({payModesToPass}) {
   console.log('upi'+payModesToPass);
  const [selectOtherApps, setSelectOtherApps] = React.useState('');
  const [showUpiBarCode, setShowUpiBarCode] = useState(false);
  const [showUpiPopUp, setshowUpiPopUp] = useState(false);
  const [payId, setPayId] = useState('');
  const [QrCodeData , setQrCodeData] = useState('');
  const [responseData, setResponseData] = useState('');
  const [validVPAerror, setvalidVPAerror] = useState('');
  const [showUpiIntent, setshowUpiIntent] = useState(false);
  const [showUpiQR, setshowUpiQR] = useState(false);
  const [showLoader, setshowLoader] = useState(false);
  const [showRetry, setShowRetry] = useState(false);
  const [showCheck, setShowCheck] = useState(false);
  const [txAmount , settxAmount ]= useState('');
  const [statusWaitTime , setWaitStatusTime] = useState('5');
  const [mode, setMode] = useState('');
  const isCheckingStatusRef = useRef(false);
  const lastVisibilityStateRef = useRef(document.visibilityState);
  const isPollingRef = useRef(false);
  const [isDisplayModeFive, setIsDisplayModeFive] = useState(false);
  const [isMotorProduct, setIsMotorProduct] = useState(false);
  const [isEligibleForUpiOTMCollect, setIsEligibleForUpiOTMCollect] = useState(false);
  const [consentExpanded, setConsentExpanded] = useState(false);
  const [showIntentStatusDialog, setShowIntentStatusDialog] = useState(false);
  const intentStatusDetailsRef = useRef(null);
  const intentPollingSessionRef = useRef(0);

   let var1;
   let var2;
  const divStyle = {
  alignSelf: 'flex-end',
  paddingBottom: '3%',
  textAlign: 'justify',
  boxSizing: 'border-box',
  fontFamily: 'Roboto, "Segoe UI", -apple-system, "Helvetica Neue", BlinkMacSystemFont, Oxygen-Sans, Ubuntu, Cantarell, sans-serif',
  fontSize: '0.8em' 
};


 
  
  useEffect(() => {
    if (payModesToPass) {

      setshowUpiIntent(!!payModesToPass.isEligibleForUpiOTMIntent);
      setshowUpiQR(!!payModesToPass.isEligibleForUpiOTMQR);
      setIsEligibleForUpiOTMCollect(!!payModesToPass.isEligibleForUpiOTMCollect);
      settxAmount(payModesToPass.txAmount);
      setShowCheck(payModesToPass.check);
      setIsMotorProduct(payModesToPass.isMotorProduct);
       if (payModesToPass.displayMode === 5) {
        setIsDisplayModeFive(true);
        settxAmount(payModesToPass.multipliedAmount);
      	} 
    }
  }, [payModesToPass]);

  const handleChange = (event) => {
    setSelectOtherApps(event.target.value);
  };

  const [vpa, setVpa] = useState('');
  const isVpaPatternValid = (value) => {
    if (!value) return false;
    const trimmed = String(value).trim();
    const atIndex = trimmed.indexOf('@');
    return atIndex > 0 && trimmed.length - atIndex - 1 >= 3;
  };

  const handleVpaChange = (event) => {
    setVpa(event.target.value);
  };

  const handleVpaClick = (event) => {
    setvalidVPAerror('');
  };
	
  const domain = getDomain();
  const actionUrl = domain+`/pay/payment/upi/thankyou`;	
	
  const handleIntentPayNow = async () => {
    setshowLoader(true);
    const queryParameters = new URLSearchParams(window.location.search);
    const order = queryParameters.get("orderNo");
    var1 = queryParameters.get("var1");
    var2 = queryParameters.get("var2");
    const mode = "UPI_OTM_INTENT";
    setMode('UPI_OTM_INTENT');
    try {
      const response = await fetch('/pay/securePayment/process/intermediate/paymentui', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          orderNo: order,
          mode: mode,
        })
      });
      const data1 = await response.json();
      console.log(data1.data);
      if(data1 && data1.data.decPayId){
       
      	
        setshowLoader(false);
       
        const decPayId = data1.data.decPayId;
        var1 = data1.data.interStatusVar1;
        var2 = data1.data.interStatusVar2;
        setPayId(decPayId);
        const intentPollingSession = ++intentPollingSessionRef.current;
        intentStatusDetailsRef.current = { payId: decPayId, var1, var2 };
        isCheckingStatusRef.current = true;
        setshowLoader(false);
        setShowIntentStatusDialog(true);
        window.location.href = data1.data.intentLink;
        setTimeout(
          () => checkTransactionStatus(decPayId, var1, var2, intentPollingSession),
          data1.data.upiWaitStatusTime * 1000
        );
        	
      } else {
        setshowLoader(false);
        // handle error
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const retryPayment = async () => {
   setShowRetry(false);
   if(mode ==='UPI_OTM'){
   handlePayNow();
   }else if(mode === 'UPI_OTM_QR'){
   handleQRPayNow();
   }else if(mode === 'UPI_OTM_INTENT'){
   handleIntentPayNow();
   }
  };
  
  
    const handleCloseDialog = () => {
    ++intentPollingSessionRef.current;
    isCheckingStatusRef.current = false;
    isPollingRef.current = false;
    setShowIntentStatusDialog(false);
    setShowUpiBarCode(false);
    setshowUpiPopUp(false);
    setShowRetry(false);
  };

  const cancelIntentPayment = async () => {
    const cancellationStartedAt = Date.now();
    const intentStatusDetails = intentStatusDetailsRef.current;
    const keepCancellationFeedbackVisible = async () => {
      const remainingTime = Math.max(0, 2000 - (Date.now() - cancellationStartedAt));
      if (remainingTime) await new Promise(resolve => setTimeout(resolve, remainingTime));
    };

    ++intentPollingSessionRef.current;
    isCheckingStatusRef.current = false;
    isPollingRef.current = false;

    try {
      if (intentStatusDetails) {
        const response = await fetchTxnStatus(
          encodeURIComponent(intentStatusDetails.payId),
          intentStatusDetails.var1,
          intentStatusDetails.var2
        );
        if (response?.status === 'TXN_SUCCESS') {
          await keepCancellationFeedbackVisible();
          setShowIntentStatusDialog(false);
          submitFormWithPayId(intentStatusDetails.payId, intentStatusDetails.var1, intentStatusDetails.var2);
          return;
        }
      }
    } catch (error) {
      console.log('Final UPI OTM Intent status check failed:', error);
    }

    await keepCancellationFeedbackVisible();
    setshowLoader(false);
    setShowIntentStatusDialog(false);
  };

  const handleQRPayNow = async () => {
    setshowLoader(true);
    const queryParameters = new URLSearchParams(window.location.search);
    const order = queryParameters.get("orderNo");
    var1 = queryParameters.get("var1");
    var2 = queryParameters.get("var2");
    const mode = "UPI_OTM_QR";
    setMode('UPI_OTM_QR');
    try {
      const response = await fetch('/pay/securePayment/process/intermediate/paymentui', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          orderNo: order,
          mode: mode,
        })
      });
      const data = await response.json();
      console.log(data);
      if(data && data.decQrPayId){
       
      	setQrCodeData(data);
        setshowLoader(false);
        setShowUpiBarCode(true);
    
        setWaitStatusTime(data.qrCodeWaitStatusTime);
        const decPayId = data.decQrPayId;
        var1 = data.interStatusVar1;
        var2 = data.interStatusVar2;
        setPayId(decPayId);
     	isCheckingStatusRef.current = true; 
        setTimeout(() => checkTransactionStatus(decPayId, var1, var2), data.qrCodeWaitStatusTime * 1000);
        	
      } else {
        setshowLoader(false);
        // handle error
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };




  const handlePayNow = async () => {
    if (vpa !== '' && isVpaPatternValid(vpa)) {
    setshowLoader(true);
    const queryParameters = new URLSearchParams(window.location.search);
    const order = queryParameters.get("orderNo");
    var1 = queryParameters.get("var1");
    var2 = queryParameters.get("var2");
    const decodedVpa = decodeURIComponent(vpa);
    const mode = "UPI_OTM";
    setMode('UPI');
    try {
      const response = await fetch('/pay/validate/vpa', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          orderNo: order,
          mode: mode,
          json: decodedVpa,
          var1: var1,
          var2: var2
        })
      });
      const data = await response.json();
      console.log(data);
      console.log('isVPAValid value:', data.data.isVPAValid);

      if (data.data.isVPAValid === 1) {
        const response1 = await fetch('/pay/securePayment/process/intermediate/paymentui', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            orderNo: order,
            mode: mode,
            vpa: decodedVpa
          })
        });
        const data1 = await response1.json();
        setQrCodeData(data1.data);
        console.log(data1);
        const decPayId = data1.data.decPayId;
        var1 = data1.data.interStatusVar1;
        var2 = data1.data.interStatusVar2;

        setPayId(decPayId);
        setshowLoader(false);
        if (data1.data.decPayId) {
          setWaitStatusTime(data1.upiWaitStatusTime);
          setshowUpiPopUp(true);
          isCheckingStatusRef.current = true;
          setTimeout(() => checkTransactionStatus(decPayId, var1, var2), data1.data.upiWaitStatusTime * 1000);
        } else {
          setshowLoader(false);
          setvalidVPAerror('Some error occured, Please try again!');
        }
      } else {
        setshowLoader(false);
        setvalidVPAerror('Please enter a valid UPI ID');
      }
    } catch (error) {
      console.error('Error:', error);
    }}
    else{
    setvalidVPAerror('Please enter a valid UPI ID');
    }
  };

  useEffect(() => {
    const handleVisibilityChange = () => {
      console.log('App Switch Detection:', {
        previousState: lastVisibilityStateRef.current,
        newState: document.visibilityState,
        isCheckingStatus: isCheckingStatusRef.current,
        isPolling: isPollingRef.current,
        timestamp: new Date().toISOString()
      });

      if (document.visibilityState === 'visible' &&
        lastVisibilityStateRef.current === 'hidden' &&
        isCheckingStatusRef.current) {
        console.log('Detected return from app switch');
        console.log('Resuming polling after app switch');
        isCheckingStatusRef.current = true;
        isPollingRef.current = true;
      } else if (document.visibilityState === 'hidden') {
        isPollingRef.current = false;
      }

      lastVisibilityStateRef.current = document.visibilityState;
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  const checkTransactionStatus = async (payId, var1, var2, intentPollingSession = null) => {
    if (!isCheckingStatusRef.current || (intentPollingSession !== null && intentPollingSession !== intentPollingSessionRef.current)) {
      return;
    }

    let retries = 0;
    const maxRetries = 60;
    isPollingRef.current = true;

    const handleVisibilityChange = () => {
      console.log('Transaction Status - Visibility Change:', {
        previousState: lastVisibilityStateRef.current,
        newState: document.visibilityState,
        isCheckingStatus: isCheckingStatusRef.current,
        isPolling: isPollingRef.current,
        timestamp: new Date().toISOString()
      });

      if (document.visibilityState === 'visible' &&
        lastVisibilityStateRef.current === 'hidden' &&
        isCheckingStatusRef.current) {
        console.log('Resuming polling after app switch');
        retries = 0;
        setShowRetry(false);
        isCheckingStatusRef.current = true;
        isPollingRef.current = true;
      } else if (document.visibilityState === 'hidden') {
        isPollingRef.current = false;
      }

      lastVisibilityStateRef.current = document.visibilityState;
    };

    const handlePageShow = (event) => {
      console.log('Transaction Status - Page Show:', {
        fromCache: event.persisted,
        isCheckingStatus: isCheckingStatusRef.current,
        isPolling: isPollingRef.current,
        timestamp: new Date().toISOString()
      });
      if (isCheckingStatusRef.current) {
        retries = 0;
        setShowRetry(false);
        isCheckingStatusRef.current = true;
        isPollingRef.current = true;
      }
    };

    const handlePageHide = (event) => {
      console.log('Transaction Status - Page Hide:', {
        toCache: event.persisted,
        isCheckingStatus: isCheckingStatusRef.current,
        isPolling: isPollingRef.current,
        timestamp: new Date().toISOString()
      });
      isPollingRef.current = false;
    };

    const cleanup = () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('pageshow', handlePageShow);
      window.removeEventListener('pagehide', handlePageHide);
      isPollingRef.current = false;
      isCheckingStatusRef.current = false;
    };

    try {
      let txnStatus = '';
      console.log('Adding transaction status event listeners...');

      document.addEventListener('visibilitychange', handleVisibilityChange);
      window.addEventListener('pageshow', handlePageShow);
      window.addEventListener('pagehide', handlePageHide);

      console.log('Transaction status event listeners added');
      console.log('Current visibility state:', document.visibilityState);
      console.log('isCheckingStatus:', isCheckingStatusRef.current);
      console.log('isPolling:', isPollingRef.current);

      while (
        isCheckingStatusRef.current &&
        (intentPollingSession === null || intentPollingSession === intentPollingSessionRef.current) &&
        retries < maxRetries
      ) {
        if (!isPollingRef.current) {
          await new Promise(resolve => setTimeout(resolve, 1000));
          continue;
        }
        retries++;
        const encodedPayId = encodeURIComponent(payId);
        const response = await fetchTxnStatus(encodedPayId, var1, var2);
        if (!isCheckingStatusRef.current || (intentPollingSession !== null && intentPollingSession !== intentPollingSessionRef.current)) {
          break;
        }
        if (response === null) {
          continue;
        }
        txnStatus = response.status;

        if (txnStatus === 'TXN_SUCCESS') {
          cleanup();
          submitFormWithPayId(payId, var1, var2);
          break;
        }
        else if (txnStatus === 'TXN_FAILURE') {
          cleanup();
          setShowUpiBarCode(false);
          setshowUpiPopUp(false);
          setShowIntentStatusDialog(false);
          setshowLoader(false);
          setShowRetry(true);
          break;
        }

        await new Promise(resolve => setTimeout(resolve, 5000));
      }

      if (!isCheckingStatusRef.current || (intentPollingSession !== null && intentPollingSession !== intentPollingSessionRef.current)) {
        cleanup();
        return;
      }

      if (retries >= maxRetries) {
        cleanup();
        setShowUpiBarCode(false);
        setshowUpiPopUp(false);
        setShowIntentStatusDialog(false);
        setshowLoader(false);
        setShowRetry(true);
      }
    } catch (error) {
      console.error('Error in checkTransactionStatus:', error);
    }
  };



const submitFormWithPayId = (payId, var1, var2) => {
  const form = document.getElementById('submitUpiOtm');
  const payIdInput = form.querySelector('input[name="payId"]');
  const var1Input = form.querySelector('input[name="var1"]');
  const var2Input = form.querySelector('input[name="var2"]');
  
  payIdInput.value = payId;
  var1Input.value = var1;
  var2Input.value = var2;
  
  form.submit();
};

  const supplierFullName = payModesToPass?.supplierFullName
    ? String(payModesToPass.supplierFullName).trim()
    : '';

  const consentToggleKeyDown = (expand) => (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      setConsentExpanded(expand);
    }
  };

  return (
    <>
       {showLoader && !showIntentStatusDialog && <Loader show={true} textToShow="Please wait while your transaction is being processed"/>}
      <form
        className="form-field"
        action={actionUrl}
        method="post"
        id="submitUpiOtm"
        autoComplete="off"
      >
        <input type="hidden" name="payId" id="payId" />
        <input type="hidden" name="var1" id="var1" value={var1} />
        <input type="hidden" name="var2" id="var2" value={var2} />
      </form>

      <div className='card-details bg-white px-7 py-5'>
        <div className='card-detail-form'>
          {showUpiIntent && (
            <>
              <div className='upi-payment-type'>
                <h3 className='relative sm:mt-2 sm:mb-1'>Block using an App<span className='  absolute right-5'>
                     </span>
                </h3>
                <div className='sm:py-1 pe-3 ps-0 sm:mt-3'>
                  <Button className='pay-now-btn' onClick={() => handleIntentPayNow()}>CHOOSE AN APP</Button>
                </div>
              </div>
            </>
          )}

          <div className="hidden md:block">
            {(showUpiQR || isEligibleForUpiOTMCollect) && (
              <div className='card-info'>
                <h5>
                  Block Payment via B-ASBA
                </h5>
                <div className='scan-pay-box'>
                  <ul>
                    {showUpiQR && (
                      <>
                        <li>
                          <h3>Scan and Block</h3>
                          <div className='barcode-icon'>
                            <ImageComponents name={"barcode"} />
                            <Button className='genrate-qrcode' onClick={() => handleQRPayNow()} >View</Button>
                          </div>
                        </li>
                      </>
                    )}
                    {isEligibleForUpiOTMCollect && (
                      <li>
                        <h3>Enter UPI ID</h3>
                        <form className='mt-3'>
                          <TextField
                            id="vpa-input"
                            label="mobilenumber@upi"
                            fullWidth
                            value={vpa}
                            error={!!validVPAerror}
                            helperText={validVPAerror}
                            onChange={handleVpaChange}
                            onClick={handleVpaClick}
                          />
                          <Button className="verify-pay-btn" onClick={() => handlePayNow()}>
                            Verify & Block
                          </Button>
                        </form>
                        <div id="stepper">
                          <ul className="steps">
                            <li className="">
                              <span>Enter your registered VPA.</span>
                            </li>
                            <li className="steps">
                              <span>Receive a &quot;Block Request&quot; on the payment app.</span>
                            </li>
                            <li className="non-active">
                              <span>Authorize the request to block the amount for this transaction.</span>
                            </li>
                          </ul>
                        </div>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            )}
          </div>
          <div className="block md:hidden">
            {(showUpiQR || isEligibleForUpiOTMCollect) && (
              <div className='card-info'>
                <h5>
                  Block Payment via B-ASBA
                </h5>
                <div className='scan-pay-box'>
                  <ul>
                    {isEligibleForUpiOTMCollect && (
                      <li>
                        <h3>Enter UPI ID</h3>
                        <form className='mt-3'>
                          <TextField
                            id="vpa-input-mobile"
                            label="mobilenumber@upi"
                            fullWidth
                            value={vpa}
                            error={!!validVPAerror}
                            helperText={validVPAerror}
                            onChange={handleVpaChange}
                            onClick={handleVpaClick}
                          />
                          <Button className="verify-pay-btn" onClick={() => handlePayNow()}>
                            Verify & Block
                          </Button>
                        </form>
                        <div id="stepper">
                          <ul className="steps">
                            <li className="">
                              <span>Enter your registered VPA</span>
                            </li>
                            <li className="steps">
                              <span>Receive a &quot;Block Request&quot; on the payment app.</span>
                            </li>
                            <li className="non-active">
                              <span>Authorize the request to block the amount for this transaction.</span>
                            </li>
                          </ul>
                        </div>
                      </li>
                    )}
                    {showUpiQR && (
                      <>
                        <li>
                          <h3>Scan and Block</h3>
                          <div className='barcode-icon'>
                            <ImageComponents name={"barcode"} />
                            <Button className='genrate-qrcode' onClick={() => handleQRPayNow()} >View</Button>
                          </div>
                        </li>
                      </>
                    )}
                  </ul>
                </div>
              </div>
            )}
          </div>
          <div className='upi-otm-consent'>
            <FormControlLabel
              control={
                <Checkbox
                  checked
                  disabled
                  tabIndex={-1}
                  inputProps={{ 'aria-readonly': true }}
                  sx={{
                    alignSelf: 'flex-start',
                    mt: '-2px',
                    '&.Mui-disabled': { color: '#0065FF' },
                  }}
                />
              }
              label={
                <span className='upi-otm-consent-text'>
                  {!consentExpanded ? (
                    <>
                      As per the IRDAI&apos;s directions, I hereby provide my express consent and authorise the{' '}
                      <span className="upi-otm-insurer-name">{supplierFullName}</span>
                      {' '}
                      <span
                        role="button"
                        tabIndex={0}
                        className="upi-otm-consent-toggle-text"
                        aria-expanded={false}
                        onClick={(e) => {
                          e.preventDefault();
                          setConsentExpanded(true);
                        }}
                        onKeyDown={consentToggleKeyDown(true)}
                      >
                        <strong className="upi-otm-consent-toggle-text-label">See more</strong>
                        <FaChevronDown aria-hidden size={12} />
                      </span>
                    </>
                  ) : (
                    <>
                      As per the IRDAI&apos;s directions, I hereby provide my express consent and authorise the{' '}
                      <span className="upi-otm-insurer-name">{supplierFullName}</span>
                      {' '}to block an amount as quoted in this proposal form (including applicable taxes), for the purpose of premium payment towards insurance. I agree and understand that this mandate shall be valid for a period of :
                      <br />
                      (i) 14 days from the date of premium block mandate or
                      <br />
                      <span className="upi-otm-consent-ii-hang">
                        (ii) Date of acceptance of this proposal, whichever is earlier and that the
                        <br />
                        blocked amount will be utilised towards premium payment upon proposal acceptance.{' '}
                        I further authorise the{' '}
                        <span className="upi-otm-insurer-name">{supplierFullName}</span>
                        {' '}to share information with the relevant entities for the purpose of blocking/releasing the premium amount.
                        {'\u00a0'}
                        <span
                          role="button"
                          tabIndex={0}
                          className="upi-otm-consent-toggle-text"
                          aria-expanded
                          onClick={(e) => {
                            e.preventDefault();
                            setConsentExpanded(false);
                          }}
                          onKeyDown={consentToggleKeyDown(false)}
                        >
                          <strong className="upi-otm-consent-toggle-text-label">See less</strong>
                          <FaChevronUp aria-hidden size={12} />
                        </span>
                      </span>
                    </>
                  )}
                </span>
              }
              sx={{ alignItems: 'flex-start', marginLeft: 0, marginRight: 0 }}
            />
          </div>
          <div className='note-box'>
            <span>
              <ImageComponents name={"notesIcon"} />
            </span>
            <h5>Please note</h5>
            <p>You’re setting up a secure one-time mandate, this will block the amount in your account, which will be deducted after your policy issuance is confirmed.</p>
          </div>
        </div>
      </div>
      
      <Dialog
        open={showUpiPopUp}
        disableEscapeKeyDown
        disablePortal
        disableAutoFocus
        BackdropProps={{
          onClick: (e) => e.stopPropagation()
        }}
      >
        <OTMUpiPaymentProcess QrCodeData = {QrCodeData} handleCloseDialog={handleCloseDialog}  vpa={vpa} />
      </Dialog>
      
      <Dialog
        open={showUpiBarCode}
        disableEscapeKeyDown
        disablePortal
        disableAutoFocus
        BackdropProps={{
          onClick: (e) => e.stopPropagation()
        }}
        className='upi-dialog'
      >
        <UpiQR  QrCodeData={QrCodeData} handleCloseDialog={handleCloseDialog} txAmount = {txAmount} mode = {mode}/>
      </Dialog>
      
      <IntentPaymentStatusDialog
        open={showIntentStatusDialog}
        title="Complete your payment. We'll confirm it automatically once it's successfull."
        onCancelPayment={cancelIntentPayment}
      />

      <Dialog
        open={showRetry}
        disableEscapeKeyDown
        disablePortal
        disableAutoFocus
        BackdropProps={{
          onClick: (e) => e.stopPropagation()
        }}
      >
        <PaymentFailedPopup  handleCloseDialog={handleCloseDialog} retryPayment={retryPayment}  />
       </Dialog>
      
      
      {showCheck && isMotorProduct && <div className="payment-error-box"  style={{
    margin: '-38px 0 0',
    fontSize: 'small',
  }}>
  Transaction confirmation status is pending. If the amount has already been deducted from your account, we recommend you wait for 15-20 minutes before making another payment attempt. 
</div>}
{!showCheck && isMotorProduct && <div className="payment-error-box"  style={{
    margin: '-38px 0 0',
    fontSize: 'small',
  }}>
  Transaction confirmation for UPI takes longer than other payment modes. Given the delay, we recommend you wait for some time before making another payment attempt using UPI.
</div>}
    </>
  )
}

export default UpiOtm;

